import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { useLocale } from "../i18n/LocaleContext";

export function CookieBanner() {
  const { t, link } = useLocale();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("imperium-consent")) {
      const timer = setTimeout(() => setVisible(true), 1600);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("imperium-consent", "accepted");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          data-testid="cookie-banner"
          className="fixed inset-x-4 bottom-4 z-40 mx-auto flex max-w-3xl flex-col items-start gap-4 border border-imperium-champagne/40 bg-imperium-offwhite p-5 shadow-[0_24px_60px_-24px_rgba(48,37,31,0.35)] sm:flex-row sm:items-center sm:justify-between sm:gap-8 sm:p-6"
        >
          <p className="text-sm leading-relaxed text-imperium-black/75">{t("cookie.text")}</p>
          <div className="flex shrink-0 items-center gap-5">
            <Link to={link("privacy")} data-testid="cookie-privacy-link" className="link-line text-[11px] font-label uppercase tracking-[0.2em] text-imperium-bronze">
              {t("cookie.more")}
            </Link>
            <button
              type="button"
              data-testid="cookie-accept-button"
              onClick={accept}
              className="border border-imperium-bronze px-5 py-2.5 text-[11px] font-label uppercase tracking-[0.2em] text-imperium-brown transition-colors hover:bg-imperium-brown hover:text-imperium-white"
            >
              {t("cookie.accept")}
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
